import { Smartphone, Globe } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { appLabel, appOf, isNativeDevice, type AdminUserDevice } from "@produce/shared";
import { formatDay } from "./format";

/**
 * Devices registered for push, of every app. This is what decides whether a
 * "they never got the notification" report is a delivery problem or simply an
 * account with no device attached at all — and, now that there are two native
 * apps, whether the device is the app the notification was sent to.
 */
export default function DeviceList({ devices }: { devices: AdminUserDevice[] }) {
  if (devices.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        No devices registered — this user cannot receive push notifications.
      </p>
    );
  }

  return (
    <ul className="space-y-2">
      {devices.map((device, index) => {
        const isNative = isNativeDevice(device);
        const Icon = isNative ? Smartphone : Globe;
        return (
          <li
            key={`${device.device_label ?? "device"}-${device.created_at}-${index}`}
            className="flex items-center gap-3 rounded-md border p-3 text-sm"
          >
            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="font-medium">{device.device_label || "Unnamed device"}</span>
            <Badge variant="outline">{isNative ? appLabel(appOf(device)) : "Web"}</Badge>
            {(device.native_platform || device.platform) && (
              <span className="text-muted-foreground">
                {device.native_platform || device.platform}
              </span>
            )}
            <span className="ml-auto text-muted-foreground">
              registered {formatDay(device.created_at)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
